import { render, staticRenderFns } from "./EmailValidation.vue?vue&type=template&id=6a2f4a22&"
import script from "./EmailValidation.vue?vue&type=script&lang=js&"
export * from "./EmailValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a2f4a22')) {
      api.createRecord('6a2f4a22', component.options)
    } else {
      api.reload('6a2f4a22', component.options)
    }
    module.hot.accept("./EmailValidation.vue?vue&type=template&id=6a2f4a22&", function () {
      api.rerender('6a2f4a22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Login/EmailValidation.vue"
export default component.exports